import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import LoginModel from '../../../../../models/user.model';
import { AppCommon } from '../../../../../providers/app-common';
import { SourcingNeedV2ViewModel } from '../../../../../models-views/sourcing-needs-v2.view.model';
import { StandardResponseModel } from '../../../../../models/project.model';

@Component({
  selector: 'app-sn-form-catering-v2',
  templateUrl: './sn-form-catering-v2.component.html',
  styleUrls: ['./sn-form-catering-v2.component.scss'],
  standalone: false
})
export class SnFormCateringV2Component implements OnInit, OnChanges {
  @Input() eventId: number | null = null;
  @Input() data: any;
  @Output() closeModal = new EventEmitter<'success' | 'cancel'>();
  
  form!: FormGroup;
  isEdit: boolean = true;
  isView: boolean = false;
  existingData: any = null;

  cateringResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
  mealTypesResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
  mealTimingsResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
  nonAlcoholicBeverageResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
  alcoholicBeverageResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
  dietaryPreferencesResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());

  constructor(
    private fb: FormBuilder, 
    private vm: SourcingNeedV2ViewModel,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.vm.parentSnFormCateringV2Component = this;
    this.initForm();
    this.vm.subscribeToCateringModels(
      this.cateringResponseModel,
      this.mealTypesResponseModel,
      this.mealTimingsResponseModel,
      this.nonAlcoholicBeverageResponseModel,
      this.alcoholicBeverageResponseModel,
      this.dietaryPreferencesResponseModel
    );
    this.vm.initGeneralCallsForCatering();
    
    setTimeout(() => {
      this.handleInputData();
    }, 300);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.handleInputData();
    }
  }

  handleInputData(): void {

    if (this.data) {
      this.existingData = this.data;
      this.isView = false;
      this.isEdit = true;
      this.form.patchValue(this.mapApiToForm(this.data));
    } else {
      this.existingData = null;
      this.isView = false;
      this.isEdit = true;
      this.form.reset();
      this.form.enable();
      this.cdr.detectChanges();
    }
  }

  mapApiToForm(data: any): any {
    return {
      catering_type: data.catering_type_details?.map((item: any) => item.id) || [],
      meal_type: data.meal_type_details?.map((item: any) => item.id) || [],
      // Some APIs use meal_timing_details (singular timing) instead of meal_timings_details
      meal_timings: (data.meal_timings_details || data.meal_timing_details)?.map((item: any) => item.id) || data.meal_timings || [],
      non_alcoholic_beverage: data.non_alcoholic_beverage_details?.map((item: any) => item.id) || [],
      alcoholic_beverage: data.alcoholic_beverage_details?.map((item: any) => item.id) || [],
      dietary_preferences: data.dietary_preferences_details?.map((item: any) => item.id) || [],
      liquor_license_required: data.liquor_license_required ?? false,
      catering_description: data.catering_description || '',
    };
  }

  initForm(): void {
    this.form = this.fb.group({
      catering_type: [[], ],
      meal_type: [[], ],
      meal_timings: [[], ],
      non_alcoholic_beverage: [[],],
      alcoholic_beverage: [[],],
      dietary_preferences: [[],],
      // liquor_license_required: [false,Validators.required],
      liquor_license_required: [false, [Validators.required]],
      // catering_description: ['',Validators.required],
    });
  }


  onSave(): void {
    if (!this.form.valid) {
      return;
    }

    const payload = this.form.value;
    const loggedInUser = AppCommon.getloggedInObject();
    const userId = loggedInUser?.user?.id;

    payload.sourcing_need = this.eventId;
    payload.is_catering_required = true;

    [
      'catering_type',
      'meal_type',
      'meal_timings',
      'non_alcoholic_beverage',
      'alcoholic_beverage',
      'dietary_preferences'
    ].forEach(key => {
      payload[key] ??= [];
    });

    if (this.isEdit && this.existingData) {
      payload.id = this.existingData.id;
      payload.modified_by = userId;
      this.vm.addUpdateSouringCatering(payload, true);
    } else {
      payload.created_by = userId;
      this.vm.addUpdateSouringCatering(payload, false);
    }
  }

  sourcingCateringAdded() {
    this.closeModal.emit('success');
    
    if (this.eventId) {
      this.vm.getSouringNeedbyId(this.eventId, 'cet-sourcing-needs-v2');
    }
  }

  onEdit(): void {
    this.isEdit = true;
    this.isView = false;
    this.form.enable();
  }

  onCancel(): void {
    this.closeModal.emit('cancel');
  }
}